import { useState, useEffect } from "react";
import { FetchTfsSrpYearRates } from "../../api/FetchTfsSrpYearRates";

export interface dataType {
  meta: {
    page?: number;
    limit?: number;
    total?: number;
    current_page?: number;
    last_page?: number;
    first_page?: number;
    first_page_url?: string;
    last_page_url?: string;
    next_page_url?: string;
    previous_page_url?: any;
  };
  data: data[];
}

export interface data {
  data: {
    model_year: number;
    discount_percentage: number;
    created_at: any;
  };
}

const default_page_size = 10;

const _data: dataType = {
  meta: {
    page: 1,
    limit: default_page_size,
  },
  data: [],
};

export const useFetchTfsSrpYearRates = (query: {
  page: number;
  limit: number;
  query_search_value?: string;
}) => {
  const [dataInfo, setDataInfo] = useState(_data);

  useEffect(() => {
    const fetchData = async () => {
      const result = await FetchTfsSrpYearRates(query);

      if (result.data.data) {
        for (const item of result.data.data) {
          item["key"] = item.tfs_srp_year_rate_id;
        }
      }

      setDataInfo(result);
    };

    fetchData();
  }, [query]);

  return dataInfo;
};
